export const lunadisPayOrigin = 'Lunadis Pay'
